// components/ui/HoneycombPattern.tsx
interface HoneycombPatternProps {
  className?: string;
  opacity?: number;
  color?: string;
  id?: string; // ← caller passes a stable, unique id
}

export function HoneycombPattern({
  className,
  opacity = 0.06,
  color = "#b45309",
  id = "honeycomb",
}: HoneycombPatternProps) {
  const patternId = `${id}-pattern`;

  return (
    <svg
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 h-full w-full ${className ?? ""}`}
      style={{ opacity }}
    >
      <defs>
        <pattern
          id={patternId}
          width="56"
          height="97"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M28 2 L54 16.5 L54 45.5 L28 60 L2 45.5 L2 16.5 Z"
            fill="none"
            stroke={color}
            strokeWidth="1.2"
          />
          <path
            d="M28 37 L54 51.5 L54 80.5 L28 95 L2 80.5 L2 51.5 Z"
            fill="none"
            stroke={color}
            strokeWidth="1.2"
          />
          <path
            d="M-28 2 L-2 16.5 L-2 45.5 L-28 60 L-54 45.5 L-54 16.5 Z"
            fill="none"
            stroke={color}
            strokeWidth="1.2"
          />
          <path
            d="M84 2 L110 16.5 L110 45.5 L84 60 L58 45.5 L58 16.5 Z"
            fill="none"
            stroke={color}
            strokeWidth="1.2"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${patternId})`} />
    </svg>
  );
}